import React from 'react';
import BitaModal from '../../../../../bitaComponents/BitaModal/BitaModal';
import { ReactComponent as Logo } from '../../../../../static/img/Icons/BITA.svg';
import BitaButton from '../../../../../components/BitaButton/BitaButton';
import style from '../../../PortfolioBasketCalculation.module.scss';

const styleClose = {
  position: 'absolute',
  fontSize: '30px',
  fontWeight: 'bold',
  top: '-10px',
  right: '0',
  cursor: 'pointer',
  padding: '10px',
  boxSizing: 'border-box',
};
const RequestCoverageSuccessful = ({
  showModalRequestCoverageSuccessful,
  setShowModalRequestCoverageSuccessful,
}) => {
  return (
    <BitaModal
      isModalOpen={showModalRequestCoverageSuccessful}
      setModalState={() => setShowModalRequestCoverageSuccessful(false)}
    >
      <div style={{ width: '600px ', minHeight: '130px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            borderBottom: '1px solid #eee',
            padding: '10px 0',
          }}
        >
          <Logo style={{ width: '30px', height: '30px', marginRight: '20px' }} />
          <h2
            style={{
              margin: '0',
              padding: '0',
              fontSize: '20px',
              textTransform: 'uppercase',
              textAlign: 'center',
              marginLeft: '-20px',
              width: '100%',
            }}
          >
            REQUEST COVERAGE
          </h2>
          <span onClick={() => setShowModalRequestCoverageSuccessful(false)} style={styleClose}>
            &times;
          </span>
        </div>
        <div>
          <div style={{ margin: '20px', textAlign: 'center' }}>
            Your request is being processed, we will contact you shortly.
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
            <button
              className={style.requestCoverageSuccessfulCancelButton}
              onClick={() => setShowModalRequestCoverageSuccessful(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </BitaModal>
  );
};

export default RequestCoverageSuccessful;
